<template>
  <div class="videoIng lw_video_bg">
    <div v-if="form.is_multilingual==2">
      <play v-if="form.type==1" :form='form' :meeting_data='meeting_data' />
      <playMp4 v-if="form.type==2" :form='form' :meeting_data='meeting_data' />
      <video_bill @goVideo='goVideo' v-if="form.id" :form='form' />
      <!-- <backHome :baseData='meeting_data'></backHome> -->
      <back :baseData='meeting_data'> </back>
    </div>
    <div v-if="form.is_multilingual==1">
      <play_en v-if="form.type==1" :form='form' :meeting_data='meeting_data' />
      <playMp4_en v-if="form.type==2" :form='form' :meeting_data='meeting_data' />
      <video_bill_en @goVideo='goVideo' v-if="form.id" :form='form' />
      <!-- <backHome :baseData='meeting_data'></backHome> -->
      <back :baseData='meeting_data'> </back>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { getWXConfig } from "@/api/login.js";
import { geiVideodetail } from '@/api/meetApi.js';
import backHome from '@/components/backHome.vue';
import playMp4 from "@/components/video/playMp4.vue";
import play from "@/components/video/play.vue";
import video_bill from "@/components/video/video_bill.vue";
import play_en from "@/components/video/play_en.vue";
import playMp4_en from "@/components/video/playMp4_en.vue";
import video_bill_en from "@/components/video/video_bill_en.vue";
import moment from 'moment';
import back from './back.vue';
export default {
  components: { back, playMp4, play, video_bill, playMp4_en, play_en, video_bill_en, backHome },
  name: "videoIng",
  data() {
    return {
      isEn: false,
      form: {},
      meeting_data: {}
    };
  },
  mounted() { },
  created() {
    $("html,body").animate({
      scrollTop: 0
    }, 500);
    this.getVideoDetail()
  },
  methods: {
    moment,
    goVideo(id) {
      // 使用 replace 修改当前路由的查询参数，而不跳转
      this.$router.replace({
        path: this.$route.path,
        query: {
          id: id
        }
      }); 
      window.location.reload();
      // 
      // this.$router.push('/videoIng?id=' + id)
      // this.getVideoDetail()
    },
    async getVideoDetail() {
      let data = await geiVideodetail({ id: this.$route.query.id, meeting_id: this.$route.query.meeting_id })
      this.form = data.payload.data
      console.log(this.form)
      this.meeting_data = data.payload.meeting_data
      document.title = this.form.title
      this.share()
      if (this.form.video_background_path) {
        document.querySelectorAll(".lw_video_bg")[0].style.background = 'url(' + this.form.video_background_path + ')';
      } else {
        document.querySelectorAll(".lw_video_bg")[0].style.backgroundColor = '#ffffff'
      }
      if (this.meeting_data.background_color) {
        document.querySelectorAll("body")[0].style.backgroundColor = this.meeting_data.background_color
        document.querySelectorAll("html")[0].style.backgroundColor = this.meeting_data.background_color
      }
    },
    async share() {
      // 
      // 
      // 注意，当直播是直接在素材库创建时可能没有meeting_data，所以这里要判断一下
      let data = null
      if (this.meeting_data && this.meeting_data.id) {
        data = await getWXConfig({ url: window.location.href, meeting_id: this.meeting_data.id })
      } else {
        data = await getWXConfig({ url: window.location.href })
        this.meeting_data.wechat_share_img_path = ''
        this.meeting_data.wechat_share_content = ''
        this.meeting_data.moments_share_img_path = ''
        this.meeting_data.moments_share_content = ''
      }

      let reg = /\\r\\n/ig

      this.WXConfig.wxShowMenu(
        data.payload,
        this.form.wechat_share_title ? this.form.wechat_share_title.replace(reg, "\r\n") : this.form.title,
        this.form.wechat_share_img_path ? this.form.wechat_share_img_path : this.meeting_data.wechat_share_img_path,
        this.form.wechat_share_content ? this.form.wechat_share_content.replace(reg, "\r\n") : this.meeting_data.wechat_share_content.replace(reg, "\r\n"),
        this.form.moments_share_title ? this.form.moments_share_title.replace(reg, "\r\n") : this.form.title,
        this.form.moments_share_img_path ? this.form.moments_share_img_path : this.meeting_data.moments_share_img_path,
        this.form.moments_share_content ? this.form.moments_share_content.replace(reg, "\r\n") : this.meeting_data.moments_share_content.replace(reg, "\r\n"),
      );

    }
  },
};
</script>

<style lang="less" scoped>
.videoIng {
  background-repeat: no-repeat !important;
  background-size: 100% 100% !important;
  background-size: 100% 100%;
  min-height: 100vh;
}
.noData {
  background-color: black;
  width: 100%;
  position: relative;
  height: 56.7vw;
  max-width: 768px;
  max-height: 436px;
  .noData_img {
    position: absolute;
    bottom: 0;
    color: #fff;
    padding: 8px;
    left: 0;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    width: 100%;
  }
}
::-webkit-scrollbar {
  width: 0px;
}
::scrollbar {
  width: 0px;
}
</style>
<style>
.baseFormBox_data .ant-cascader-picker,
.video_baseFormBox .ant-calendar-picker {
  width: 100%;
}
</style>